import { Component, HostListener, OnInit, QueryList, ViewChildren, ViewEncapsulation } from '@angular/core';
import { NgbdSortableHeader, SortEvent } from '../../../../../shared/directives/NgbdSortableHeader';
import { Observable } from 'rxjs';
import { EmpresasService } from '../../../../../shared/services/empresas.service';
import { Utils } from '../../../../../shared/utils/Utils';
const Swal = require("sweetalert2");
import * as data from '../../../../../shared/data/dashboard/social'
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-empresas-inactivas',
  templateUrl: './empresas-inactivas.component.html',
  styleUrls: ['./empresas-inactivas.component.scss']
})
export class EmpresasInactivasComponent {
  public facebook = data.facebook;
  public selected = [];

  public searchText = ''; // Texto para búsqueda
  total$: Observable<number>; // Observable para obtener el total de elementos
  propietarios: any[] = [];


  public show: boolean = false
  openDropdown: any = null; // Variable para controlar qué menú está abierto
  openDropdown2: any = null; // Variable para controlar qué menú está abierto
  sortColumn: string = '';
  sortDirection: string = 'asc'; // 'asc' o 'desc'
  searchTerm: string = '';
  dropdownStates: boolean[] = [];
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>; // Para la cabecera de la tabla

  tableItem$: any;
  filteredTableItems: EmpresasService[];
  propietariosCumpleanios: any[];
  conteoPorMes: Record<string, number>;
  empresas: any[] = [];
  editMode: boolean;
  empresaselecionada: any;
  formEmpresa!: FormGroup; // Asegurar que formEmpresa se inicializa correctamente


  constructor(
    private empresasService: EmpresasService,
  ) { }

  ngOnInit() {
    this.listarEmpresas();

  }

  pageSize: number = 5;
  page: number = 1;
  totalItems: number;


  stopPropagation(event: Event) {
    event.stopPropagation(); // Evita que el clic dentro del dropdown cierre el menú
  }
  // Función para ordenar las columnas
  onSort({ column, direction }: SortEvent) {
    // Restablecemos la dirección de orden de todas las columnas
    this.headers.forEach((header) => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    // Establecemos la columna y dirección de orden
    // this.service.sortColumn = column;
    // this.service.sortDirection = direction;
  }
  sortData(column: string) {
    // Actualizar el criterio de ordenamiento:
    // Si ya se está ordenando por la columna indicada, se alterna la dirección;
    // de lo contrario, se establece la columna con orden ascendente.
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }
  
    // Ordenar la lista filtrada (filteredTableItems) en función del criterio seleccionado.
    this.filteredTableItems.sort((a, b) => {
      // Convertir los valores a cadena en minúsculas para una comparación consistente.
      const valA = a[column] ? a[column].toString().toLowerCase() : '';
      const valB = b[column] ? b[column].toString().toLowerCase() : '';
  
      // Si ambos valores son numéricos, se realiza una comparación numérica.
      if (!isNaN(Number(valA)) && !isNaN(Number(valB))) {
        return this.sortDirection === 'asc'
          ? Number(valA) - Number(valB)
          : Number(valB) - Number(valA);
      } else {
        // En caso contrario, se comparan como cadenas de texto.
        return this.sortDirection === 'asc'
          ? valA.localeCompare(valB)
          : valB.localeCompare(valA);
      }
    });
  }
  

  /*** Método de filtrado ***/
filterData() {
  const searchTextLower = this.searchText.toLowerCase().trim();
  if (!searchTextLower) {
    this.filteredTableItems = [...this.empresas];
  } else {
    this.filteredTableItems = this.empresas.filter(empresa => {
      const nit = empresa.nit ? empresa.nit.toString().toLowerCase() : '';
      const nombre = empresa.nombre ? empresa.nombre.toString().toLowerCase() : '';
      // Buscar en el array de categorias
      const tipo = (empresa.categorias || [])
        .filter(cat => cat && cat.text)       // eliminar nulls y elementos sin text
        .map(cat => cat.text.toLowerCase())  // obtener solo el text en minúsculas
        .join(' ');                          // unir en un solo string para buscar

      return nit.includes(searchTextLower) ||
             nombre.includes(searchTextLower) ||
             tipo.includes(searchTextLower);
    });
  }
  this.page = 1; // Reinicia la paginación al aplicar el filtro
}


  get filteredPropietarios() {
    if (!this.searchTerm) {
      return this.empresas; // Mostrar todos los datos si no hay búsqueda
    }

    const term = this.searchTerm.toLowerCase();
    return this.empresas.filter(empresas => {
      // Ajusta los campos por los que quieres buscar
      return (
        empresas.nit.toLowerCase().includes(term) ||
        empresas.digito.toLowerCase().includes(term) ||
        empresas.nombre.toLowerCase().includes(term)

      );
    });
  }

  toggleDropdown(index: number) {
    this.dropdownStates = this.dropdownStates.map((state, i) => (i === index ? !state : false));
  }



  //recibe el id de la tabla vista, nombre con el que descargará el archivo, titulo del documento
  exportToPDF(tableId: string, nameFile: string, titleFile: string) {
    Utils.exportToPDF(tableId, nameFile, titleFile);
  }


  exportarExcel(tableId: string, nameFile: string) {
    Utils.exportVisibleTableToExcel(tableId, nameFile);
  }

listarEmpresas(): void {
  this.empresasService.getAllEmpresasInactivas().subscribe({
    next: (data) => {
      this.empresas = data
        .map(empresa => ({ ...empresa, showMenu: false }));
        
      this.filteredTableItems = this.empresas; // ✅ para paginar correctamente
    },
    error: (err) => console.error('❌ Error al actualizar la tabla de empresas activas:', err)
  });
}



  activarempresa(nit: string) {
    this.avisoactivarempresa(nit);
  }

  avisoactivarempresa(nit: string | number) {

    Swal.fire({
      title: 'Activar',
      text: `¿Deseas activar la empresa con nit: ${nit}?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, activar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.empresasService.activarempresa(String(nit)).subscribe({
          next: () => {
            Swal.fire('¡Activado!', 'La empresa ha sido activada.', 'success');
            this.listarEmpresas(); // Actualiza la lista después de la activación
          },
          error: (error) => {
            console.error('❌ Error al activar la Empresa:', error);
            Swal.fire('Error', 'No se pudo activar la empresa.', 'error');
          }
        });
      }
    });

}
}